export default __webpack_public_path__ + "static/media/home-events-conference-img-17.083cd7b1.jpg";